
import request from "@/utils/request";

export const getSystemWebConfig = () => {
  return request.get('/api/app/config/system_webConfig');
};

export const getAppDownloadConfig = () => {
  return request.get('/api/app/config/app_download');
};

// 服务协议
export const getUserRegisterContract = () => {
  return request.get('/api/app/config/user_register_contract');
};

// 隐私政策
export const getUserProtectContract = () => {
  return request.get('/api/app/config/user_protect_contract');
};

// 协议
export const getUserContract = (params: Record<string, string>) => {
  return request.get('/api/contract/get', { params });
};

// 关于我们
export const getAboutUs = () => {
  return request.get('/api/app/config/about_us');
};

// 注销账号协议
export const getCancelAccountContract = () => {
  return request.get('/api/app/config/cancel_account_contract');
};

// 意见反馈
export const feedback = (data: { content: string }) => {
  return request.post('/api/app/feedback', data);
};

// 发送登录态的短信验证码
export const getAuthSmsCode = (data: { smsType: 'cancelAccount' | 'editMobile' | 'editPassword', mobile?: string }) => {
  return request.post('/user-center/api/app/auth/smsCode', data);
};

// 发送无登录态的短信验证码
export const getNoAuthSmsCode = (data: { mobile: string; smsType: 'login' | 'getPassword' | 'editMobile' | 'loginOauth' }) => {
  return request.post('/user-center/api/app/v1/smsCode', data);
};

// 验证旧手机号
export const verifyOldMobile = (data: { smsCode: string }) => {
  return request.post('/user-center/api/app/user/changeMobile/verifyOld', data);
};

// 更换手机号
export const changeMobile = (data: { mobile: string; smsCode: string; oldSmsCode?: string }) => {
  return request.post('/user-center/api/app/user/changeMobile/verifyNew', data);
};

// 更新密码
export const updatePassword = (data: { password: string; smsCode: string; mobile?: string }) => {
  return request.put('/user-center/api/app/update/password', data);
};

// 忘记密码
export const resetPassword = (data: { mobile: string; smsCode: string; password: string }) => {
  return request.put('/user-center/api/app/reset/password', data);
};

// 微信授权
export const wxAuth = `${location.origin}/user-center/authorize/authUrl`;

// 获取订单地址
export const getOrderAddress = (addressId: string, orderId: string) => {
  return request.get(`/api/app/address/${addressId}/${orderId}`);
};

// 更新订单地址
export const updateOrderAddress = (orderId: string, data: { address_id: string }) => {
  return request.put(`/backend-api/app/myOrder/address/modify/${orderId}`, data);
};

// 根据渠道获取app下载地址
export const getAppPkgUrl = (params: any) => {
  return request.get('/backend-api/app/getAppPkgUrl', { params });
}

// 获取试用引导页配置
export const getTrialGuidePageConfigs = () => {
  return request.get('/backend-api/trial/guide/page-configs');
}
